<template>
  <div class="sv-page">
    <header class="sv-page-header">
      <div>
        <span class="sv-page-header__eyebrow">Visão geral da operação</span>
        <h1>Dashboard</h1>
        <p>Acompanhe volume, duração, armazenamento e processamento das gravações.</p>
      </div>
    </header>

    <div class="sv-section-heading">
      <h2>Gravações de hoje</h2>
    </div>

    <div class="row">
      <div class="col-xxl-7 col-xxxl-12">
        <div class="row">
          <div class="col-lg-3 col-12 col-sm-6 col-xl-3 col-xxl-4 col-xxxl-3 col-md-6">
            <DashboardDaySuccess />
          </div>
          <div class="col-lg-3 col-12 col-sm-6 col-xl-3 col-xxl-4 col-xxxl-3 col-md-6">
            <DashboardDayError />
          </div>
          <div class="col-lg-3 col-12 col-sm-6 col-xl-3 col-xxl-4 col-xxxl-3 col-md-6">
            <DashboardDayTime />
          </div>
          <div class="col-lg-3 col-12 col-sm-6 col-xl-3 col-xxl-4 col-xxxl-3 col-md-6">
            <DashboardDaySize />
          </div>
        </div>
      </div>
      <div class="col-xxl-12 col-xxxl-12">
        <DashboardCardsTodayInformations />
      </div>
      <div class="col-xxl-12 col-xxxl-12">
        <DashboardUploadTotalsHour />
      </div>

      <div class="col-12">
        <div class="sv-section-heading">
          <h2>Gravações do mês atual</h2>
        </div>
      </div>

      <div class="col-xxl-4">
        <MetricDashboardMonthGraphic />
      </div>

      <div class="col-xxl-8 col-xxxl-8">
        <CardsDashboardMonth />
      </div>

      <div class="col-12">
        <div class="sv-section-heading">
          <h2>Gravações do ano atual</h2>
        </div>
      </div>

      <div class="col-xxl-12 col-xxxl-12">
        <MetricDashboardYearGraphic />
      </div>

      <div class="row col-12 flex-column flex-sm-row area-dashboard-graphic-semester-and-quarters">
        <div class="d-flex flex-column justify-content-around mb-10 mt-30 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
          <div class="sv-section-heading">
            <h3>Semestre atual</h3>
          </div>

          <div>
            <MetricDashboardSemesterGraphic />
          </div>
        </div>

        <div class="d-flex flex-column justify-content-around mb-10 mt-30 col-12 col-sm-12 col-lg-6 col-xl-6 col-xxl-6 col-xxxl-6">
          <div class="sv-section-heading">
            <h3>Trimestre atual</h3>
          </div>

          <div>
            <MetricDashboardQuarterGraphic />
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="sv-section-heading">
          <h2>Gravações de todo o período</h2>
        </div>
      </div>

      <div class="col-xxl-12">
        <MetricDashboardTotals />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import DashboardDaySuccess from "../../components/Dashboard/DashboardDaySuccess.vue";
import DashboardDayError from "../../components/Dashboard/DashboardDayError.vue";
import DashboardDayTime from "../../components/Dashboard/DashboardDayTime.vue";
import DashboardDaySize from "../../components/Dashboard/DashboardDaySize.vue";
import DashboardUploadTotalsHour from "../../components/Dashboard/DashboardUploadTotalsHour.vue";
import DashboardCardsTodayInformations from "../../components/Dashboard/DashboardCardsTodayInformations.vue";
import CardsDashboardMonth from "../../components/Dashboard/CardsDashboardMonth.vue";
import MetricDashboardMonthGraphic from "../../components/Dashboard/MetricDashboardMonthGraphic.vue";
import MetricDashboardYearGraphic from "../../components/Dashboard/MetricDashboardYearGraphic.vue";
import MetricDashboardSemesterGraphic from "../../components/Dashboard/MetricDashboardSemesterGraphic.vue";
import MetricDashboardQuarterGraphic from "../../components/Dashboard/MetricDashboardQuarterGraphic.vue";
import MetricDashboardTotals from "../../components/Dashboard/MetricDashboardTotals.vue";

import { mapGetters, mapActions } from 'vuex';

export default defineComponent({
  name: "DashboardPage",
  components: {
    DashboardDaySuccess,
    DashboardDayError,
    DashboardDayTime,
    DashboardDaySize,
    DashboardUploadTotalsHour,
    DashboardCardsTodayInformations,
    MetricDashboardMonthGraphic,
    CardsDashboardMonth,
    MetricDashboardYearGraphic,
    MetricDashboardSemesterGraphic,
    MetricDashboardQuarterGraphic,
    MetricDashboardTotals
  },
  data() {
    return {
      intervalId: null as ReturnType<typeof setInterval> | null
    };
  },
  watch: {
    getLoadedOperations(data){
      if(data){
        this.destroyInterval();

        this.setDashboardDayCards();
        this.setDashboardMonthCards();
        this.setDashboardQuarterCards();
        this.setDashboardSemesterCards();
        this.setDashboardYearCards();
        this.setMetricsTotals();

        this.getDashboardData();
      }
    }
  },
  computed: {
    ...mapGetters([
      "getDashboardDayCardsFinish",
      "getDashboardMonthCardsFinish",
      "getDashboardQuarterCardsFinish",
      "getDashboardSemesterCardsFinish",
      "getDashboardYearCardsFinish",
      "getMetricsTotalsFinish",
      "getOperations",
      "getLoadedOperations"
    ])
  },
  mounted(){
    this.setOperations();
  },
  methods: {
    ...mapActions([
      "setDashboardDayCards",
      "setDashboardMonthCards",
      "setDashboardYearCards",
      "setDashboardSemesterCards",
      "setDashboardQuarterCards",
      "setMetricsTotals",
      "setOperations"
    ]),
    destroyInterval(){
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    },
    getDashboardData() {
      this.intervalId = setInterval(() => {
        if (
          this.getDashboardDayCardsFinish &&
          this.getDashboardMonthCardsFinish &&
          this.getDashboardQuarterCardsFinish &&
          this.getDashboardSemesterCardsFinish &&
          this.getDashboardYearCardsFinish &&
          this.getMetricsTotalsFinish
        ) {
          this.setDashboardDayCards();
          this.setDashboardMonthCards();
          this.setDashboardQuarterCards();
          this.setDashboardSemesterCards();
          this.setDashboardYearCards();
          this.setMetricsTotals();
        }
      }, 300000);
    }
  },
  beforeUnmount() {
    this.destroyInterval();
  }
});
</script>
